import { UserDetails } from 'src/app/shared/models/user-details.model';

export class UserHelper {
    private userOperations: string[];
    private scopeOperations: string[] = [];
    constructor(private userDetails: UserDetails) {
        const accountOperations = userDetails.profile.scopeOperations
            .map((x: any) => x.operationNames);

        const flatOperations = [].concat.apply([], accountOperations);
        this.scopeOperations = Array.from(new Set<string>(flatOperations));
        this.userOperations = userDetails.profile.applicationOperations.concat(this.scopeOperations);
    }

    public IsOperationAvailable(operation: string): boolean {
        return this.userOperations.indexOf(operation) > -1;
    }

    public AreAvailableInAnyScope(operations: string[]) {
        return this.userDetails.profile.scopeOperations.some(x => operations.every(op => x.operationNames.indexOf(op) > -1));
    }
}
